"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRetentionTypeList = void 0;
const baseTypes_1 = require("../../../core/baseTypes");
const getRetentionTypeList = () => [
    baseTypes_1.RETENTION_TYPE.days,
    baseTypes_1.RETENTION_TYPE.months,
];
exports.getRetentionTypeList = getRetentionTypeList;
//# sourceMappingURL=getRetentionTypeList.js.map